// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"9845344f","828":"52d30e46"}[chunkId] + ".chunk.js";
};